/* Kudos glyph (card svmgRALhXjiq): the 🫂 emoji rendered per-platform and sat
   outside the vector icon set the rest of the app uses. This is the same heart
   the compose menu's Kudos tile already draws, so one glyph per action. */
export const KUDOS_GLYPH = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 0 0-7.8 7.8l1 1L12 21.2l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.8z" />
  </svg>
);

/* Card-family glyphs (card KOFFfNfIwDq1, founder email 2026-10-22): the game
   round card drew 🎲 and the question card ❓ — text glyphs that render
   per-platform and sit outside the vector set the rest of the app draws. Both
   are the real Lucide shapes (tic-tac-toe, circle-question-mark, lucide-static
   v1.61.0), inlined the same way the concierge chip inlines sparkles — no icon
   dependency. Same box as KUDOS_GLYPH (20px, 1.8 stroke) so the three cards in
   this slot keep one weight down the stream. */
export const GAME_GLYPH = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <path d="M12 2v20" />
    <path d="m21 16-5 5" />
    <path d="m21 21-5-5" />
    <path d="M22 12H2" />
    <path d="M8 3 3 8" />
    <path d="M8 8 3 3" />
    <circle cx="18.5" cy="5.5" r="2.5" />
    <circle cx="5.5" cy="18.5" r="2.5" />
  </svg>
);

export const QUESTION_GLYPH = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="12" cy="12" r="10" />
    <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3" />
    <path d="M12 17h.01" />
  </svg>
);
